import Api from '@services/api';

export const INTEGRATION_COMMUNITIES_REQUEST = 'admin/INTEGRATION_COMMUNITIES_REQUEST';
export const INTEGRATION_COMMUNITIES_SUCCESS = 'admin/INTEGRATION_COMMUNITIES_SUCCESS';
export const INTEGRATION_COMMUNITIES_FAILURE = 'admin/INTEGRATION_COMMUNITIES_FAILURE';
export const INTEGRATION_COMMUNITIES_UPDATE = 'admin/INTEGRATION_COMMUNITIES_UPDATE';

export const IMPORT_COMMUNITY_REQUEST = 'admin/IMPORT_COMMUNITY_REQUEST';
export const IMPORT_COMMUNITY_SUCCESS = 'admin/IMPORT_COMMUNITY_SUCCESS';
export const IMPORT_COMMUNITY_FAILURE = 'admin/IMPORT_COMMUNITY_FAILURE';

export const IMPORT_COMMUNITIES_BULK_REQUEST = 'admin/IMPORT_COMMUNITIES_BULK_REQUEST';
export const IMPORT_COMMUNITIES_BULK_SUCCESS = 'admin/IMPORT_COMMUNITIES_BULK_SUCCESS';
export const IMPORT_COMMUNITIES_BULK_FAILURE = 'admin/IMPORT_COMMUNITIES_BULK_FAILURE';

export const UPDATE_NETWORK_INTEGRATION_REQUEST = 'admin/UPDATE_NETWORK_INTEGRATION_REQUEST';
export const UPDATE_NETWORK_INTEGRATION_SUCCESS = 'admin/UPDATE_NETWORK_INTEGRATION_SUCCESS';
export const UPDATE_NETWORK_INTEGRATION_FAILURE = 'admin/UPDATE_NETWORK_INTEGRATION_FAILURE';

export const UPDATE_NETWORK_BY_ID_REQUEST = 'admin/UPDATE_NETWORK_BY_ID_REQUEST';
export const UPDATE_NETWORK_BY_ID_SUCCESS = 'admin/UPDATE_NETWORK_BY_ID_SUCCESS';
export const UPDATE_NETWORK_BY_ID_FAILURE = 'admin/UPDATE_NETWORK_BY_ID_FAILURE';

export type IntegrationNetwork = {
  type: 'network';
  id: string;
  externalId: string[];
  name: string;
  hasIntegration: boolean;
  organisationId: string;
  enabledComponents: string[];
  welcomeMailTemplate: string | null;
  createdAt: string;
  deletedAt: string | null;
};

export type CommunityGroup = {
  externalId: string;
  name: string;
  linked_with: IntegrationNetwork[];
};

export const fetchIntegrationCommunities = (organisationId: string) => async (dispatch: any) => {
  dispatch({ type: INTEGRATION_COMMUNITIES_REQUEST });

  try {
    const response = await Api.get(`/v1/organisations/${organisationId}/integration/networks`);

    dispatch({
      type: INTEGRATION_COMMUNITIES_SUCCESS,
      data: response.data,
    });

    return response.data;
  } catch (error: any) {
    dispatch({
      type: INTEGRATION_COMMUNITIES_FAILURE,
      error: error.message,
    });
    return Promise.reject(error);
  }
};

export const importCommunity = (organisationId: string,
  communityData: { name: string; external_id: string[] }) => async (dispatch: any) => {
  dispatch({ type: IMPORT_COMMUNITY_REQUEST });

  const response = await Api.post(`/v2/organisations/${organisationId}/networks`, communityData);

  dispatch({
    type: IMPORT_COMMUNITY_SUCCESS,
    data: response.data,
  });

  await dispatch(fetchIntegrationCommunities(organisationId));
};

export const importCommunitiesBulk = (organisationId: string,
  communitiesData: Array<{ name: string; external_id: string[] }>) => async (dispatch: any) => {
  dispatch({ type: IMPORT_COMMUNITIES_BULK_REQUEST });

  const response = await Api.post(`/v2/organisations/${organisationId}/networks`, communitiesData as any);

  dispatch({
    type: IMPORT_COMMUNITIES_BULK_SUCCESS,
    data: response.data,
  });

  await dispatch(fetchIntegrationCommunities(organisationId));
};


export const updateNetworkById = (networkId: string,
  networkData: { externalId: string[], name?: string }) => async (dispatch: any) => {
  dispatch({ type: UPDATE_NETWORK_BY_ID_REQUEST });

  try {
    const response = await Api.put(`/v2/networks/${networkId}`, networkData);

    dispatch({
      type: UPDATE_NETWORK_BY_ID_SUCCESS,
      data: response.data,
    });

    return response.data;
  } catch (error: any) {
    dispatch({
      type: UPDATE_NETWORK_BY_ID_FAILURE,
      error: error.message
    });
    throw error;
  }
};
